import { API, graphqlOperation } from "aws-amplify";
import { getLLMProject } from "../graphql/queries";
import { GetLLMProjectQuery } from "../API";
import { GraphQLResult } from "@aws-amplify/api";



export async function fetchLLMProject(
  id: string
): Promise<GraphQLResult<GetLLMProjectQuery>> {
  return API.graphql(
    graphqlOperation(getLLMProject, {
      id: id,
    })
  ) as Promise<GraphQLResult<GetLLMProjectQuery>>;
}
